export default {
  index: [
    {
      path: '/qyzdplan',
      component: resolve => require(['./qyzdplanIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/qyzdplan/_router.js